import { render, staticRenderFns } from "./LabelTableStatus.vue?vue&type=template&id=5403bf6d"
import script from "./LabelTableStatus.vue?vue&type=script&lang=js"
export * from "./LabelTableStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports